import React from 'react';
import { motion } from 'framer-motion';
import { OrnateDivider } from './Decorations';
export function PracticalInfo() {
  return <section className="py-20 px-4 relative bg-radial-spotlight-bottom" data-id="element-91">
      <div className="max-w-3xl mx-auto text-center" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-93">
          <OrnateDivider className="mb-16" data-id="element-94" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-95">
            <div data-id="element-96">
              <h3 className="text-gold uppercase tracking-widest text-sm mb-3 font-medium" data-id="element-97">
                Dress Code
              </h3>
              <p className="text-xl font-serif text-velvet mb-2" data-id="element-98">
                Business Smart
              </p>
              <p className="text-velvet/60 text-sm font-light" data-id="element-99">
                A touch of theatrical flair is highly encouraged.
              </p>
            </div>
            <div data-id="element-100">
              <h3 className="text-gold uppercase tracking-widest text-sm mb-3 font-medium" data-id="element-101">
                Parking
              </h3>
              <p className="text-xl font-serif text-velvet mb-2" data-id="element-102">
                Available On-Site
              </p>
              <p className="text-velvet/60 text-sm font-light" data-id="element-103">
                Complimentary parking at the Lillian Prime MS Centre.
              </p>
            </div>
          </div>

          <div id="rsvp" className="p-8 border border-carrot/20 rounded-lg bg-parchment-dark/50 backdrop-blur-sm shadow-xl" data-id="element-104">
            <h3 className="text-3xl font-serif text-velvet mb-4" data-id="element-105">
              Will You Join Us?
            </h3>
            <p className="text-velvet/70 mb-8 font-light" data-id="element-106">
              Kindly confirm your attendance before sunrise on the day.
            </p>
            <button className="w-full sm:w-auto px-10 py-4 font-serif text-lg tracking-wide text-velvet border-2 border-carrot hover:bg-carrot hover:text-parchment transition-all duration-300 rounded-sm box-glow-carrot" data-id="element-107">
              RSVP Now
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}